import { mapActions } from 'vuex';

export default {
	data() {
		return {
			logData: {},
			logVisible: false,
			logMotherData: {}
		}
	},

	methods: {
		...mapActions([
			'getHcmApprovalByRelated'
		]),
		// 打开抽屉
		async onOpenLog(row) {
			let params;
			if(row) {
				params = {
					related: row.hid
				}
			}else {
				params = {
					related: this.data.hid
				}
			}
			if(row.bmcstatus === '1' || row.campaignExamine) {
				this.logData = {};
				this.logMotherData = row.campaignExamine;

			}else {
				this.logMotherData = {};
				const res = await this.getHcmApprovalByRelated(params);
				this.sortLogData(res);
				console.log(res.childList);
				this.logData = res;
			}
			this.logVisible = true;
		},
		// 给日志数据排序
		sortLogData(data) {
			const logData = data.childList;
			const res = [];
			function findNextNodeItem(id) {
				return logData.find(item => item.lastnode === id);
			}
			const firstItem = logData.find(item => !item.lastnode);

			let currentId = firstItem.id;
			res.push(firstItem);
			while(res.length < logData.length) {
				console.log(currentId);

				const nextItem = findNextNodeItem(currentId);
				res.push(nextItem);
				currentId = nextItem.id;
			}
			data.childList = res;
		},
	}
}
